<template>
  <div class="column q-pa-md ">
    <div class="col-1 row q-gutter-md items-center" v-if="!isFetching">
      <avatar :project="project" size="45px"/>
      <div class="column">
        <h5 class="q-ma-xs">Выполнение задачи {{ performTask?.task.code }}</h5>
        <div class="q-ma-xs text-subtitle2" v-if="performTask?.startTime">c {{
            dayJs.utc(performTask?.startTime).local().format("L")
          }} до {{
            dayJs.utc(performTask?.executionTime).local().format("L")
          }}
        </div>
        <div class="q-ma-xs text-subtitle2" v-else>до {{ dayJs.utc(performTask?.executionTime).local().format("L") }}
        </div>
      </div>
      <div class="row  q-gutter-xs items-center">
        <q-btn icon="share" round color="primary">
          <q-popup-proxy @beforeShow="generate">
            <q-banner inline-actions>
              <q-input :model-value="linkUrl" readonly :loading="generating"/>
              <template v-slot:action>
                <q-btn @click="copy(linkUrl)" flat :icon="copied ? 'done' : 'content_copy'" color="primary"/>
              </template>
            </q-banner>
          </q-popup-proxy>
        </q-btn>
        <q-btn icon="download" round color="positive" :loading="isLoading" @click="downloadPhotos()">
          <q-tooltip>Скачать</q-tooltip>
        </q-btn>
        <template v-if="project?.yourPermission == 'ADMINISTRATOR' || project?.yourPermission == 'WRITE'">
          <q-btn v-if="performTask?.task.status === 'OPEN'" icon="edit" round color="primary"
                 :to="`${performTaskId}/edit`"/>
          <q-btn v-if="performTask?.status === 'CLOSED'" icon="check" round color="positive" @click="openTask">
            <q-tooltip>Открыть</q-tooltip>
          </q-btn>
        </template>
      </div>
    </div>
    <div class="col-1 row items-center" v-else>
      <q-skeleton type="QAvatar"/>
      <div class="column ">
        <q-skeleton class="q-ma-xs" type="text" width="100px"/>
        <q-skeleton class="q-ma-xs" type="text" width="20px"/>
      </div>
    </div>
    <div class="col-10 row">
      <div class="col-12">
        <q-expansion-item switch-toggle-side expand-separator label="Детали">
          <div class="row  q-ma-md  items-center q-gutter-md">

            <div class="col-4">
              Количество фото:
              <span> {{ performTask?.uploadedPhoto }} / {{ performTask?.task.photoCount }}</span>
            </div>
            <div class="col-4">
              <span>Статус: </span>
              <q-chip :color="statusColors[performTask?.status]" text-color="white">{{
                  status[performTask?.status]
                }}
              </q-chip>
            </div>
            <div class="col-4">
              <span>Состояние: </span>
              <q-chip :color="stateColors[performTask?.state]" text-color="white">{{
                  states[performTask?.state]
                }}
              </q-chip>
            </div>
            <div class="col-4">
              <span>Дата начала: </span>
              <span v-if="performTask?.startTime">{{ dayJs.utc(performTask?.startTime).local().format("LLLL") }}</span>
              <span v-else>Отсутствует</span>
            </div>
            <div class="col-4">
              <span>Дата выполнения: </span>
              <span v-if="performTask?.completedAt">{{
                  dayJs.utc(performTask?.completedAt).local().format("LLLL")
                }}</span>
              <span v-else>Еще не выполнена</span>
            </div>
          </div>
        </q-expansion-item>
      </div>
      <div class="col-12" v-if="performTask?.comment">
        <q-expansion-item switch-toggle-side expand-separator label="Комментарий">
          <div class="q-ma-md">
            {{ performTask?.comment }}
          </div>
        </q-expansion-item>
      </div>
      <div class="col-12" v-if="performTask?.photosPreview.length > 0">
        <q-expansion-item switch-toggle-side expand-separator label="Фотографии">
          <div class="row q-gutter-md q-ma-md">
            <div class="col-12 col-md-2" v-for="photo in performTask?.photosPreview.slice(0, 3)">
              <q-card>
                <q-img fit="cover" :ratio="16 / 9" v-ripple
                       :src="photoPreviewUrl(photo.address)"/>
              </q-card>
            </div>
            <div class="col-12 col-md-2" :style="$q.screen.xs ? ({ minHeight: '150px' }) : {}">
              <q-card v-ripple @click="openPhotos = !openPhotos" class="bg-grey-4 fit text-center ">
                <q-icon name="more_horiz" color="white" class="absolute-center" size="60px"/>
              </q-card>
            </div>
          </div>
        </q-expansion-item>
      </div>
      <div class="col-12" v-if="performTask?.status === 'OPEN' && !performTask?.task.geo">
        <q-expansion-item switch-toggle-side expand-separator label="Загрузить фото">
          <div class="q-ma-xs">
            <q-form @submit="uploadPhotos" class="q-gutter-md">
              <q-file v-model="files" multiple label="Фотографии" clearable use-chips bottom-slots>
                <template v-slot:hint>
                  <div>
                    Этот сайт защищен reCAPTCHA, и к нему применяются
                    <a href="https://policies.google.com/privacy">Политика конфиденциальности</a> и
                    <a href="https://policies.google.com/terms">Условия обслуживания Google</a>.
                  </div>
                </template>
              </q-file>
              <div>
                <q-btn :loading="loading" label="Загрузить" type="submit" color="primary"/>
              </div>
            </q-form>
          </div>
        </q-expansion-item>
      </div>
      <div class="col-12" v-if="performTask?.status === 'OPEN'">
        <q-expansion-item switch-toggle-side expand-separator :disable="!closable"
                          :caption="!closable ? 'Недостаточно фотографий' : undefined" label="Выполнить">
          <div class="q-ma-xs">
            <q-form @submit="completeTask" class="q-gutter-md">
              <q-input v-model="comment" type="textarea" label="Комментарий"></q-input>
              <div>
                <q-btn label="Выполнить" type="submit" color="primary" :disable="!closable"/>
              </div>
            </q-form>
          </div>
        </q-expansion-item>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {useProjectStore} from "../../store/project";
import {storeToRefs} from "pinia";
import {computed, ref} from "vue";
import {status, statusColors, stateColors, states} from "../../util/state";
import {useReCaptcha} from 'vue-recaptcha-v3'
import {useRoute} from "vue-router";
import {
  useClosePerformTask,
  useOpenPerformTask,
  usePerformTask, usePerformTaskLink,
  usePerformTaskPhotoUpload,
  usePhotoUpload,
  useUploadToken
} from "../../composables/performTask";
import {useDayJs} from "../../composables/dayjs";
import Avatar from "../../components/Avatar.vue";
import {usePhotoStore} from "../../store/photo";
import {useAsyncState, useClipboard, useEventBus} from "@vueuse/core";
import {UploadRequest} from "../../models/performTask";
import {taskKey} from "../../util/events";
import {useAllPerformTaskPhotos, useAllTaskPhotos, useTaskLink} from "../../composables/task";
import {useQuasar} from "quasar";
import JSZip from "jszip";
import {saveAs} from "file-saver";
import {useLoading} from "../../util/loading";
import {photoCdnUrl} from "../../util/photoCdn";

const route = useRoute()
const dayJs = useDayJs()
const {executeRecaptcha, recaptchaLoaded} = useReCaptcha()
const $q = useQuasar()
const projectStore = useProjectStore()
const {project} = storeToRefs(projectStore)

const projectId = computed(() => Number(route.params.projectId))
const performTaskId = computed(() => Number(route.params.performTaskId))

const {data: performTask, isFetching, execute} = usePerformTask(projectId, performTaskId)
const photoStore = usePhotoStore()

const {open: openPhotos} = storeToRefs(photoStore)

const comment = ref("")
const loading = ref(false)
const files = ref([])

const {state: captcha, execute: executeCaptcha} = useAsyncState<string | null>(async () => {
  await recaptchaLoaded()
  return await executeRecaptcha('uploadPhoto')
}, null, {immediate: false})


const {data: link, isFetching: generating, execute: generate} = usePerformTaskLink(projectId, performTaskId)

const linkUrl = computed(() => `${window.location.origin}/performTask?share=${link.value?.token}`)

const {text, copy, copied, isSupported} = useClipboard({source: linkUrl})

const photoPreviewUrl = (address: string) => photoCdnUrl(address, {
  preview: '1280x960',
  formatAfterCaption: 'jpeg',
})

const {data: photoToken, execute: executeUploadToken} = useUploadToken(projectId, performTaskId, captcha)

const closable = computed(() => (performTask.value?.uploadedPhoto ?? 0) >= (performTask.value?.task.photoCount ?? 1))

const {execute: executeClose} = useClosePerformTask(projectId, performTaskId, comment)
const {execute: executeOpen} = useOpenPerformTask(projectId, performTaskId)

const taskEvent = useEventBus(taskKey)


async function uploadPhotos() {
  loading.value = true

  try {
    const photos = []
    await executeUploadToken(true)
    let start = Date.now();
    for (let file of files.value) {
      const formData = new FormData()
      formData.set('signature', photoToken.value?.signature ?? "")
      formData.set('expire', photoToken.value?.expire.toString() ?? "")
      formData.set('image', file)
      const {data} = await usePhotoUpload(formData)
      const id = data.value;
      if (id) {
        photos.push(id.id)
      }
      const end = Date.now();
      const elapsed = (end - start) / 1000;
      if (elapsed > 100) {
        await executeCaptcha()
      }
    }
    const request: UploadRequest = {
      photos: photos.map(a => ({
        uuid: a,
        createdAt: dayJs().utc().format(),
        latitude: null,
        longitude: null
      }))
    }
    await usePerformTaskPhotoUpload(projectId, performTaskId, request)
    await execute(true)
  } catch (e) {

  }

  files.value = []
  loading.value = false
}

async function openTask() {
  await executeOpen(true)
  await execute(true)
  taskEvent.emit('refresh')
  $q.dialog({
    title: "Задача",
    message: "Задача была открыта",
    cancel: false
  })
}

async function completeTask() {
  await executeClose(true)
  await execute(true)
  taskEvent.emit('refresh')
}

const {isLoading, startLoading, stopLoading, withLoading} = useLoading();

const downloadPhotos = withLoading(async () => {
  const zip = new JSZip();
  const {data} = await useAllPerformTaskPhotos(projectId, performTaskId);
  const photos = data.value?.content;
  const photosUrl = photos?.map(p => photoCdnUrl(p.address, {
    preview: '960x960',
    formatBeforeCaption: 'jpeg',
    caption: p.caption ? {text: p.caption, fontSize: 30} : null,
  }))

  if (photosUrl) {
    for (let i = 0; i < photosUrl?.length; i++) {
      const url = photosUrl[i];
      const res = await fetch(url);
      const blob = await res.blob();
      zip.file(`${i}.jpeg`, blob);
    }
  }

  const content = await zip.generateAsync({type: "blob"});

  saveAs(content, `Фото-${performTask.value?.task.name}-${dayJs.utc(performTask?.value?.executionTime).local().format("L")}.zip`);
});
</script>
